import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, XHRBackend } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/Operator';

import { QuoteInfoService } from "../services/quote-info.service";
import { CurrentUserService } from "../services/current-user.service";
import { CurrentUser } from '../model/current-user';
import { Quote } from '../model/quote';
import { ToasterService, ToasterConfig} from 'angular2-toaster';
import { CookieService } from "angular2-cookie/core";
import { HttpErrorResponse } from '../model/httperror-response';

@Injectable()
export class AuthenticatedHttpService extends Http {

    private globalOptions: RequestOptions;
    currentUser: CurrentUser
    quote: Quote;
    private BEARER_TOKEN: string = 'Bearer';
    private USER_PROFILE_NAME: string = 'CLU';

    config: ToasterConfig = new ToasterConfig({
        positionClass: 'toast-bottom-right'
    });

    constructor(
        backend: XHRBackend,
        defaultOptions: RequestOptions,
        private quoteInfoService: QuoteInfoService,
        private currentUserService: CurrentUserService,
        private toastService: ToasterService,
        private cookieService: CookieService
    ) {
            super(backend, defaultOptions);

			let headers = new Headers({ 'Content-Type': 'application/json' });
            headers.append('Content', 'application/json');
            headers.append('Access-Control-Allow-Origin', '*');
            headers.append('Accept', 'q=0.8;application/json;q=0.9');
            headers.append('Pragma', 'no-cache');
            headers.append('Cache-Control', 'no-cache');
            headers.append('Authorization', 'bearer ' + this._getBearerTokenFromCookie());

            this.globalOptions = new RequestOptions();
            this.globalOptions.headers = headers;

            this.quoteInfoService.quote$.subscribe(x => this.quote = x);

            this.currentUserService.currentUser$.subscribe(cu => {
                this.currentUser = cu;
            });
    }

    get(url: string): Observable<Response> {
        var request = super.get(url, this.globalOptions).share();
        request.subscribe(null, (error: any) => {
            this._checkAuthentication(error);
        });

        return request;
    }

    post(url: string, data: any): Observable<Response> {
        var request = super.post(url, data, this.globalOptions).share();
        request.subscribe(null, (error: any) => {
            this._checkAuthentication(error);
        });

        return request;
    }

    put(url: string, data: any): Observable<Response> {
        var request = super.put(url, data, this.globalOptions).share();
        request.subscribe(null, (error: any) => {
            this._checkAuthentication(error);
        });

        return request;
    }

    delete(url: string): Observable<Response> {
        var request = super.delete(url, this.globalOptions).share();
        request.subscribe(null, (error: any) => {
            this._checkAuthentication(error);
        });

        return request;
    }

    public getBaseURLFromCookie(): string {
        let name = 'baseURL';
        let baseURL = ''
        let match = document.cookie.match(new RegExp(name + '=([^;]+)'));
        if (match) { baseURL = match[1].toString(); }

        return baseURL;
    }

    public handleError(error: Response | any) {
        let errorResponse = new HttpErrorResponse(0,'');

        let defaultMessage: string = 'Oops! Looks like something went wrong with your request. Please try again or contact MFG Support for assistance.';
        if (error instanceof Response) {
            errorResponse.errorCode = error.status;

            if (error.status === 500) {
                errorResponse.errorMessage = defaultMessage;
            } else {
                const body = error.json() || '';

                if (body.Message.indexOf("errorCode") > 0) {
                    let httpResponse = JSON.parse(body.Message) || defaultMessage;
                    errorResponse.errorCode = (httpResponse.errorCode) ? httpResponse.errorCode : defaultMessage;
                    errorResponse.errorMessage = (httpResponse.errorMessage) ? httpResponse.errorMessage : defaultMessage;
                } else {
                    errorResponse.errorCode = error.status;
                    errorResponse.errorMessage = body.Message;
                }
            }

            switch (error.status) {
                case 401:
                    errorResponse.errorCode = error.status;
                    defaultMessage = 'You do not have sufficient permissions to access this quote.'
                    break;
                default:
                    defaultMessage = errorResponse.errorMessage;
                    break;
            }
            errorResponse.errorMessage = defaultMessage;

            console.log(`${error.status} - ${error.statusText || ''} ${defaultMessage}`);
        } else {
            errorResponse.errorCode = 500;          // general error code
            errorResponse.errorMessage = defaultMessage;
        }
        //console.error(defaultMessage);
        return Observable.throw(errorResponse);
    }

    private _checkAuthentication(response: Response) {
        switch (response.status) {
            case 401:
                //this.currentUserService.setLockQuoteStatusOnRedirectOrClose(this.quote.quoteId, false, Number(this.currentUser.cmhUserId))
                //this.cookieService.remove(this.BEARER_TOKEN);
                //localStorage.removeItem(this.USER_PROFILE_NAME);
                //this.cookieService.put('LoginExpired','LoginHasExpired')
                //window.location.href = "/web/#!/login/expired";
                break;
            default:
                break;
            //case 400:
            //    this.toastService.pop('Error', 'Error!', response.statusText);
            //    break;
        }

    }

    private _getBearerTokenFromCookie(): string {
        let name = 'Bearer';
        let tokenData = ''
        let match = document.cookie.match(new RegExp(name + '=([^;]+)'));
        if (match) { tokenData = match[1].toString(); }

        return tokenData;
    }

    get standardHeaders() {
        return this.globalOptions;
    }

    get getBearerTokenForHeader(): string {
        return ('bearer ' + this._getBearerTokenFromCookie());
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/services/authenticatedhttp.service.ts